import axios from "../interceptors";
import { reqHeader_protected } from "../headers";
import { API_PROTECTED_PATH, API_URL_PRD } from "../config/config";
import qs from "qs";
import store from "../../store";
import ApiClient from "../requests";

export async function getLevels(payload: string) {
  const _authToken = store.authToken;
  if(!_authToken) return null;

  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}evaluation/getLevels?lang=${payload}`;
  const res = await ApiClient.get(Url, _authToken);
  return res;
}

export async function getQuizzes(payload: {id: number; lg: string}) {
  const _authToken = store.authToken;
  if(!_authToken) return null;  

  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}evaluation/getLevelQuizzes?level_id=${payload.id}&lang=${payload.lg}`;
  const res = await ApiClient.get(Url, _authToken);
  return res;
}

export async function getQuizzQuestions(payload: any) {
  const _authToken = store.authToken;
  if(!_authToken) return null;

  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}evaluation/getQuestions?type=&quiz_id=${payload.id}&lang=${payload.lg}`;
  const res = await ApiClient.get(Url, _authToken);
  return res;
}

/**
 * Send quiz results to API
 * @param {Object} results - Object containing quizz results
 */
export async function  sendQuizzResults(data: any) {
  // console.log(
  //   "🚀 ~ file: helpers.js ~ line 588 ~ sendQuizzResults ~ results",
  //   data
  // );
  const _authToken = store.authToken;

  if (!_authToken) return null
  /*     const form = new FormData();
  Object.keys(data).map((key) => form.append(key, data[key])); */

  return axios
    .post(
      API_URL_PRD + API_PROTECTED_PATH + "evaluation/saveResponses",
      qs.stringify(data, { encode: false }),
      reqHeader_protected(_authToken)
    )
    .then((res) => res.data)
    .catch((error) =>
      console.log(
        "sendQuizzResults  : Axios call error: ",
        JSON.stringify(error)
      )
    );
}